import * as React from 'react';
import {ResourceType} from '../../../@types/resource-type';
import StrictDeleteModal from '../../form-components/StrictDeleteModal.component';

export default function DeleteResource(props: {
    open: boolean;
    resourceType: ResourceType;
    resourceName: string;
    subResources: string;
    additionalWarning?: string;
    actionLabel?: string;
    isDeleting?: boolean;
    progressMessage?: string;
    onClose: () => void;
    handleDelete: () => void;
    
}): React.ReactElement {
   
    const { open, resourceType, resourceName, subResources, additionalWarning, actionLabel, isDeleting, progressMessage, handleDelete, onClose } = props;

    
    return (
        <StrictDeleteModal
            open={open}
            resourceType={resourceType}
            resourceName={resourceName}
            subResources={subResources}
            additionalWarning={additionalWarning}
            actionLabel={actionLabel}
            isDeleting={isDeleting}
            progressMessage={progressMessage}
            onClose={onClose}
            handleDelete={handleDelete}
        />
    );
}


    